export class EnaioWorkflowModelParticipant {
    guid: string;
    name: string;
    type: string;
}
